import * as React from 'react';
import { Box, Cell, Layout } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { CookieCategoryTextsCard } from './categories-texts/categories-texts';
import { ResetLogSection } from './reset-log/reset-log';
import { NavigationContext } from '@src/context/navigation-store/navigation-store';
import { AppContext } from '@src/context/store';
import { isAppEnabled } from '@src/context/selectors/ui-settings';
import { PageRoute } from '@src/types';

export const AdvancedOptionsComponent = () => {
  const { navigateToRoute } = React.useContext(NavigationContext);
  const state = React.useContext(AppContext);

  if (!isAppEnabled(state)) {
    navigateToRoute(PageRoute.BANNER_SETTINGS);
    return null;
  }

  return (
    <Layout cols={1} dataHook={DataHooks.AdvancedPage}>
      <Cell>
        <Box marginBottom={'36px'}>
          <CookieCategoryTextsCard />
        </Box>
        <Box marginBottom={'36px'}>
          <ResetLogSection />
        </Box>
      </Cell>
    </Layout>
  );
};
